import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/plus-icon.png'
import _imports_1 from '@/assets/images/icn-favorites-folder-menu.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-91d096d8")

_pushScopeId("data-v-91d096d8")
const _hoisted_1 = { class: "mylist-folder-page" }
const _hoisted_2 = { class: "mylist-folder-page-folder-operation-append" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "mylist-folder-page-folder-operation-append-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "mylist-folder-page-folder-operation-append-button-text-container" }
const _hoisted_5 = { class: "commonButtonText mylist-folder-page-folder-operation-append-button-text" }
const _hoisted_6 = { class: "mylist-folder-page-folder-operation-delete" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "mylist-folder-page-folder-operation-delete-button-image",
  src: _imports_1
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")
  const _component_CommonDialog = _resolveComponent("CommonDialog")
  const _component_CommonOKDialog = _resolveComponent("CommonOKDialog")
  const _component_MyListFolderOperation = _resolveComponent("MyListFolderOperation")
  const _component_FavoritesFolderNameInputDialog = _resolveComponent("FavoritesFolderNameInputDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "mylist-folder-page-folder-operation",
      style: _ctx.styleFolderOperation
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.appendFolderAction(...args))),
          class: "mylist-folder-page-folder-operation-append-button"
        }, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.operationAppendText), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.folderOperationAction(...args))),
          class: "mylist-folder-page-folder-operation-delete-button"
        }, [
          _hoisted_7
        ])
      ])
    ], 4),
    _createVNode("div", {
      class: "mylist-folder-page-body",
      onScrollPassive: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onScroll($event)))
    }, [
      _createVNode("div", {
        class: "mylist-folder-page-body-spacer",
        style: _ctx.styleBodySpacer
      }, null, 4),
      _createVNode(_component_CommonRecipeList, {
        key: _ctx.updateDisplayKey,
        recipes: _ctx.recipeList,
        mode: _ctx.deleteMode,
        onSelectRecipe: _ctx.selectRecipeHandler,
        onSelectDelete: _ctx.deleteRecipeHandler
      }, null, 8, ["recipes", "mode", "onSelectRecipe", "onSelectDelete"])
    ], 32),
    _createVNode(_component_CommonDialog, {
      showDialog: _ctx.showDialog,
      message: _ctx.deleteMessage,
      positiveLabel: _ctx.okText,
      onNegativeClick: _ctx.cancelHandler,
      onPositiveClick: _ctx.deleteHandler
    }, null, 8, ["showDialog", "message", "positiveLabel", "onNegativeClick", "onPositiveClick"]),
    _createVNode(_component_CommonOKDialog, {
      showDialog: _ctx.showOKDialog,
      message: _ctx.completeOKDialogMessage,
      onOkClick: _ctx.completeOKDialogHandler
    }, null, 8, ["showDialog", "message", "onOkClick"]),
    _createVNode(_component_MyListFolderOperation, {
      showDialog: _ctx.showFolderOperation,
      onSelectClick: _ctx.folderOperationHandler
    }, null, 8, ["showDialog", "onSelectClick"]),
    _createVNode(_component_FavoritesFolderNameInputDialog, {
      showDialog: _ctx.showRenameFolderDialog,
      folderName: _ctx.folderName,
      key: _ctx.updateInputFolderNameKey,
      onCloseClick: _ctx.closeRenameFolderDialogHandler,
      onAppendClick: _ctx.renameFolderHandler
    }, null, 8, ["showDialog", "folderName", "onCloseClick", "onAppendClick"]),
    _createVNode(_component_CommonDialog, {
      showDialog: _ctx.showApiErrorDialog,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      onNegativeClick: _ctx.errorCancelHandler,
      onPositiveClick: _ctx.retryHandler
    }, null, 8, ["showDialog", "title", "message", "onNegativeClick", "onPositiveClick"])
  ]))
})